import './LoginStyle.css';
import fEMR_logo from '../resources/fEMR_logo.png';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { RoleContext } from '../App';


const Welcome = () => {
  const {setRole} = useContext(RoleContext);
  let navigate = useNavigate();

  return (
    <div className="container">
      <div className="header">
        <img className="logo" src={fEMR_logo} alt="" />
        <p className="user">ICD Application</p>
      </div>
      <div className="role-box">
        <p className="user">Welcome</p>
        <button className="role-btn" onClick={()=> {
          setRole("Arbiter");
          navigate('/login');
          }}>Arbiter</button>
        <button className="role-btn" onClick={()=> {
          setRole("Coder");
          navigate('/login');
          }}>Coder</button>
        <button className="role-btn" onClick={()=> {
          setRole("Coder Admin");
          navigate('/login');
          }}>Coder Admin</button>
        <button className="role-btn" onClick={()=> {
          setRole("Site Admin");
          navigate('/login');
          }}>Site Admin</button>
      </div>
    </div>
  );
};

export default Welcome;